export const DEFAULT_LOCALE = 'en';
export const DEFAULT_FONT_SRC = 'https://fonts.googleapis.com/css?family=Roboto&display=swap';
export const STRIPE_LIB_URL = 'https://js.stripe.com/v3/';
